export interface Plan {
  id: string;
  name: string;
  duration: {
    months: number;
    label: string;
  };
  pricing: {
    current: number;
    original?: number;
    currency: string;
    discount?: {
      percentage: number;
      label: string;
    };
    // Optional runtime-applied promotion metadata
    referralSavings?: number; // amount saved by referral code only (currency units)
    promoPercent?: number; // total percent off (event + referral)
    trialEligible?: boolean;
    trialPeriodDays?: number;
  };
  description: string;
  features: { text: string; isHighlighted: boolean; isPromo?: boolean }[];
  tags?: { text: string; backgroundColor: string; textColor: string }[];
  cta: string;
  unit: string;
  style: {
    isPopular?: boolean;
    gradientFrom: string;
    gradientVia?: string;
    gradientTo: string;
    textColor: string;
    buttonStyle: {
      background: string;
      hoverBackground: string;
      borderColor?: string;
      textColor: string;
    };
  };
}

export const plans: Plan[] = [
  {
    id: "annual",
    name: "plans.annual.name",
    duration: {
      months: 12,
      label: "plans.annual.duration"
    },
    pricing: {
      current: 2790,
      original: 5880,
      currency: "NT$",
      discount: {
        percentage: 52,
        label: "plans.annual.discount"
      }
    },
    description: "plans.annual.description",
    features: [
      { text: "plans.annual.features.0", isHighlighted: false, isPromo: true },
      { text: "plans.annual.features.1", isHighlighted: true, isPromo: false },
      { text: "plans.annual.features.2", isHighlighted: true, isPromo: false },
      { text: "plans.common.features.0", isHighlighted: false, isPromo: false },
      { text: "plans.common.features.1", isHighlighted: false, isPromo: false },
      { text: "plans.common.features.2", isHighlighted: false, isPromo: false },
      { text: "plans.common.features.3", isHighlighted: false, isPromo: false },
    ],
    tags: [
      { text: "plans.common.tags.0", backgroundColor: "bg-red-500", textColor: "text-red-50" },
      // { text: "plans.common.tags.1", backgroundColor: "bg-sky-500", textColor: "text-sky-50" },
      // { text: "plans.common.tags.2", backgroundColor: "bg-sky-500", textColor: "text-sky-50" }
    ],
    cta: "plans.annual.cta",
    unit: "plans.annual.unit",
    style: {
      isPopular: true,
      gradientFrom: "from-yellow-200",
      gradientVia: "via-yellow-300",
      gradientTo: "to-amber-500",
      textColor: "text-slate-900",
      buttonStyle: {
        background: "bg-red-500",
        hoverBackground: "hover:bg-red-600",
        borderColor: "border-red-600",
        textColor: "text-white"
      }
    }
  },
  {
    id: "quarterly",
    name: "plans.quarterly.name",
    duration: {
      months: 3,
      label: "plans.quarterly.duration"
    },
    pricing: {
      current: 1470,
      currency: "NT$"
    },
    description: "plans.quarterly.description",
    features: [
      { text: "plans.quarterly.features.0", isHighlighted: false, isPromo: true },
      { text: "plans.common.features.0", isHighlighted: false, isPromo: false },
      { text: "plans.common.features.1", isHighlighted: false, isPromo: false },
      { text: "plans.common.features.2", isHighlighted: false, isPromo: false },
      { text: "plans.common.features.3", isHighlighted: false, isPromo: false },
    ],
    tags: [
      // { text: "plans.common.tags.1", backgroundColor: "bg-sky-500", textColor: "text-sky-50" },
      // { text: "plans.common.tags.2", backgroundColor: "bg-sky-500", textColor: "text-sky-50" }
    ],
    cta: "plans.quarterly.cta",
    unit: "plans.quarterly.unit",
    style: {
      gradientFrom: "from-slate-100",
      gradientVia: "via-sky-100",
      gradientTo: "to-sky-200",
      textColor: "text-sky-950",
      buttonStyle: {
        background: "bg-slate-900",
        hoverBackground: "hover:bg-slate-800",
        borderColor: "border-slate-700",
        textColor: "text-slate-50"
      }
    }
  }
];